// extracted by mini-css-extract-plugin
export var border = "_r-8";
export var brand = "_r-t";
export var button = "_r-l";
export var center = "_r-a";
export var centered = "_r-6";
export var closeButton = "_r-c";
export var disabledWrapper = "_r-m";
export var error = "_r-p";
export var extraLarge = "_r-4";
export var extraSmall = "_r-1";
export var fill = "_r-i";
export var footer = "_r-h";
export var footerAction = "_r-j";
export var footerButtons = "_r-k";
export var header = "_r-7";
export var headerWithClose = "_r-d";
export var icon = "_r-o";
export var info = "_r-s";
export var inline = "_r-9";
export var large = "_r-3";
export var main = "_r-e";
export var modal = "_r-0";
export var nearFull = "_r-5";
export var neutral = "_r-u";
export var noPadding = "_r-g";
export var none = "_r-v";
export var scrollable = "_r-f";
export var small = "_r-2";
export var success = "_r-r";
export var tight = "_r-n";
export var titleIcon = "_r-b";
export var warn = "_r-q";